import { configureStore } from '@reduxjs/toolkit';
import childrenReducer from './slices/childrenSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        children: childrenReducer,
        
    },
});